import { useState } from 'react';
import { CheckCircle } from 'lucide-react';
import { PageLayout } from '../components/layout/PageLayout';
import { useMissingClockOut, useConfirmClockOut } from '../hooks';
import { useToast } from '../components/ui/toast';

export function ConfirmClockout() {
  const { data: items, isLoading } = useMissingClockOut();
  const confirm = useConfirmClockOut();
  const toast = useToast();
  const [actualFor, setActualFor] = useState<string | null>(null);
  const [actualTime, setActualTime] = useState('');

  async function doConfirm(date: string, mode: 'shift_end' | 'actual', actual_time?: string) {
    try {
      await confirm.mutateAsync({ date, mode, actual_time });
      setActualFor(null);
      setActualTime('');
    } catch (e) {
      toast.error(e instanceof Error ? e.message : 'เกิดข้อผิดพลาด');
    }
  }

  return (
    <PageLayout title="ยืนยันเวลาเลิกงาน">
      <p className="text-sm text-gray-600 mb-4">
        วันที่คุณลืมสแกนออกงาน — เลือก “เลิกตามกะ” หรือระบุเวลาจริง เพื่อให้ระบบคิดเวลาให้ถูกต้อง
      </p>

      {isLoading ? (
        <p className="text-sm text-gray-500">กำลังโหลด…</p>
      ) : !items || items.length === 0 ? (
        <div className="card p-6 text-center">
          <CheckCircle className="w-10 h-10 mx-auto mb-2 text-[#2f7d52]" />
          <p className="font-medium">ไม่มีวันที่ต้องยืนยัน</p>
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((it) => (
            <div key={it.date} className="card p-4">
              <div className="font-medium">{it.date}</div>
              <div className="text-xs text-gray-500 mb-3">ลืมสแกนออกงาน</div>

              {actualFor === it.date ? (
                <div className="space-y-2">
                  <label className="label">เวลาเลิกจริง</label>
                  <input type="time" value={actualTime} onChange={(e) => setActualTime(e.target.value)} className="input" />
                  <div className="flex gap-2">
                    <button onClick={() => { setActualFor(null); setActualTime(''); }} className="btn-secondary flex-1 text-sm">ยกเลิก</button>
                    <button
                      disabled={!actualTime || confirm.isPending}
                      onClick={() => doConfirm(it.date, 'actual', actualTime)}
                      className="btn-primary flex-1 text-sm"
                    >
                      ยืนยันเวลานี้
                    </button>
                  </div>
                </div>
              ) : (
                <div className="flex gap-2">
                  <button disabled={confirm.isPending} onClick={() => doConfirm(it.date, 'shift_end')} className="btn-primary flex-1 text-sm">
                    เลิกตามกะ
                  </button>
                  <button onClick={() => setActualFor(it.date)} className="btn-secondary flex-1 text-sm">
                    ระบุเวลาจริง
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </PageLayout>
  );
}
